import React, { useCallback, useContext } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material';
import GlobalContext from 'contexts/GlobalContext';
import Cookies from 'js-cookie';
import { APP_DOMAIN, DESCOPE_COOKIE } from 'utils/urls';

const AccessTokenExpiredMessageModal = () => {
  const { openAccessTokenModal, setOpenAccessTokenModal } = useContext(GlobalContext);

  const closeAccessTokenModal = useCallback(() => {
    setOpenAccessTokenModal(false);
    // Clear cookies and reload to show embedded login
    Cookies.remove(DESCOPE_COOKIE as string, { path: '/' });
    Cookies.remove(DESCOPE_COOKIE as string, { path: '/', domain: `.${APP_DOMAIN}` });
    window.location.reload();
  }, [setOpenAccessTokenModal]);

  return (
    <Dialog
      open={openAccessTokenModal}
      onClose={closeAccessTokenModal}
      aria-labelledby='modal-modal-title'
      aria-describedby='modal-modal-description'>
      <DialogTitle id='alert-dialog-title'>Session Expired</DialogTitle>
      <DialogContent>
        <DialogContentText id='alert-dialog-description'>
          Your session has expired. Please log in again.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={closeAccessTokenModal}>Log In</Button>
      </DialogActions>
    </Dialog>
  );
};

export default AccessTokenExpiredMessageModal;
